import { useSearchParams } from "react-router-dom";
import AdminLayout from "../../../components/AdminLayout";
import Abas from "../../../components/Abas";
import { Main } from "../../styled";
import { useState } from "react";
import { useEffect } from "react";
import Esqueleto from "../../../components/Esqueleto";
import { useRef } from "react";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../../../utils/config";
import ReactApexChart from "react-apexcharts";
import { FilterDaysComponent } from "../../../components/filterDays";
import Plantio from "../../../../models/Plantio";
import CustomHandle from "../../../../utils/CustomHandle";
import { addDays, formatDate } from 'date-fns';
import GraphLinhaPlantios  from "../GraphLinhaPlantios";
import GraphLinhaUsuarios from "../GraphLinhaUsuarios";
import GraphBarraPlantios from "../GraphBarraPlantios";
import PlantiosPorLocalidade from "../PlantiosPorLocalidade";
import UsuariosPorLocalidade from "../UsuariosPorLocalidade";
import EspeciesMaisPlantadas from "../EspeciesMaisPlantadas";


// Seções do relatório. A aba ativa vai na URL (?aba=usuarios): F5 e link
// compartilhado voltam para a mesma seção. Aba desconhecida cai na primeira.
const ABAS = [
  { id: "plantios", rotulo: "Plantios" },
  { id: "usuarios", rotulo: "Usuários" },
  { id: "especies", rotulo: "Espécies" },
  { id: "evolucao", rotulo: "Evolução" },
];

function Home() {
  const [params, setParams] = useSearchParams();
  const aba = ABAS.some((a) => a.id === params.get("aba")) ? params.get("aba") : ABAS[0].id;
  const trocarAba = (id) => setParams({ aba: id }, { replace: true });

  const [loading, setLoading] = useState(true);
  const [selectedEstado, setSelectedEstado] = useState('todos');

  return (
    <AdminLayout>
      <Main>

        <div className="content">
          <section>
            <div className="top">
              <div className="title">
                <h2>Relatórios</h2>
                <span>Análise por região, estado e cidade, espécies mais plantadas e evolução ao longo do tempo. Os números gerais estão no Painel.</span>
              </div>

            </div>

          </section>

          <Abas abas={ABAS} ativa={aba} onChange={trocarAba} idBase="relatorio" rotulo="Seções do relatório" />

          <section className="graphic-container" role="tabpanel" id={`relatorio-painel-${aba}`} aria-labelledby={`relatorio-${aba}`}>
            {aba === "plantios" && <PlantiosPorLocalidade />}
            {aba === "usuarios" && <UsuariosPorLocalidade />}
            {aba === "especies" && <EspeciesMaisPlantadas />}

            {aba === "evolucao" && <>
              {loading && <Esqueleto variante="grafico" quantidade={2} rotulo="Carregando gráficos" /> }

              {selectedEstado === 'todos' ?
                <GraphLinhaPlantios setLoading={setLoading} setSelectedEstado={setSelectedEstado}/> :
                <GraphBarraPlantios setLoading={setLoading} setSelectedEstado={setSelectedEstado} selectedEstado={selectedEstado}/>
              }
              <GraphLinhaUsuarios setLoading={setLoading}/>
            </>}
          </section>

        </div>
      </Main>
    </AdminLayout>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);